module.exports = __webpack_public_path__ + "static/basket-20188ef5289c365e8b1ba040a653a0d1.png";